import {
  IconButton,
  IconName,
  IconSize,
  KebabMenu
} from '@focaldata/cin-ui-components'
import { useAppDispatch, useAppSelector } from '../../../App.store'
import {
  DraftQuestionnaireEntry,
  QuestionSettingCode
} from '../../../data/model/questionnaire'
import useRemoveQuestionnaireSetting from '../../../hooks/questionnaire/useRemoveQuestionnaireSetting'
import { getQuestionSettings } from '../../../utils/questionnaireUtils'
import {
  removeQuestionSetting,
  selectSettingsByQuestionId
} from '../Questionnaire.slice'
import { getEntryId } from '../Questionnaire.utils'
import useEntrySettingValues from './useEntrySettingValues'

interface Props {
  entry: DraftQuestionnaireEntry
}

export const AutoSumMenu = ({ entry }: Props) => {
  const removeQuestionnaireSetting = useRemoveQuestionnaireSetting(entry)
  const dispatch = useAppDispatch()
  const entrySettingValues = useEntrySettingValues(entry.number)
  const settingValues =
    useAppSelector((state) =>
      selectSettingsByQuestionId(state, getEntryId(entry))
    ) || entrySettingValues
  const questionSettings = getQuestionSettings(settingValues)

  const handleDelete = async () => {
    const entryId = getEntryId(entry)

    // Remove the auto-sum setting
    dispatch(
      removeQuestionSetting({
        questionLk: entryId,
        settingCode: QuestionSettingCode.AutoSumTarget
      })
    )
    removeQuestionnaireSetting([QuestionSettingCode.AutoSumTarget])
  }

  const autoSumTarget = questionSettings.get(QuestionSettingCode.AutoSumTarget)

  return (
    <KebabMenu
      kebabMenuOptions={[
        {
          id: 1,
          textItem: 'Delete',
          onClickItem: handleDelete
        }
      ]}
      menuButton={
        <IconButton
          smallHoverShadowSize
          iconName={IconName.Functions}
          iconSize={IconSize.Large}
          tooltipText={`Auto-sum: entries must total ${autoSumTarget}`}
        />
      }
    />
  )
}
